import { api } from "../lib/apiClient";

// Ajouter une action dans l’historique
export async function addHistoryAction(action) {
  const res = await api.post("/history", action);
  return res.data;
}

// Récupérer l’historique complet de l’utilisateur
export async function getUserHistory() {
  const res = await api.get("/history");
  return res.data;
}
